import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as LogoActions from './logo.actions';
import {
    ResponseStatus,
    IStatusMessage,
    DisplayMessageMinimum
} from '../../shared';
import * as fromShared from '../../shared';
import { catchError, concatMap, flatMap, switchMap } from 'rxjs/operators';
import { LogoService } from '../logo.service';

@Injectable()
export class LogoEffects {
    constructor(private actions$: Actions, private service: LogoService) {}

    getLogo$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(LogoActions.getLogo),
            switchMap(a =>
                this.service.getLogo(a.UploadType).pipe(
                    flatMap(resp => [
                        LogoActions.loadLogos({
                            logos: resp
                        }),
                        new fromShared.Errors.RemoveErrors(
                            resp
                                .filter(
                                    x =>
                                        x.Status.StatusCode ===
                                        ResponseStatus.Success
                                )
                                .map(x => x.Uploadtype)
                        ),
                        new fromShared.Errors.SetErrors(
                            [
                                ...resp
                                    .filter(
                                        a =>
                                            a.Status.StatusCode >=
                                            DisplayMessageMinimum
                                    )
                                    .map(a => a.Status)
                            ].filter(fromShared.Errors.filterErrors)
                        )
                    ]),
                    catchError(fromShared.Errors.handleServiceError)
                )
            )
        );
    });

    putLogo$ = createEffect(() =>
        this.actions$.pipe(
            ofType(LogoActions.putLogo),
            switchMap(a =>
                this.service.putLogo(a.logo).pipe(
                    flatMap(c => [
                        LogoActions.updateLogo({
                            logo: {
                                id: a.logo.Uploadtype,
                                changes: c.Items[0]
                            }
                        }),
                        LogoActions.getLogo({ UploadType: 'Web Logo' }),
                        new fromShared.Errors.RemoveErrors(
                            c.Items.filter(
                                x =>
                                    x.Status.StatusCode ===
                                    ResponseStatus.Success
                            ).map(x => x.Uploadtype.toString())
                        ),
                        new fromShared.Errors.SetErrors(
                            [
                                ...c.ErrorMessages.map(
                                    x =>
                                        ({
                                            StatusCode: -1,
                                            Message: x,
                                            MsgProcessID: 0,
                                            MsgEntityID: ''
                                        } as IStatusMessage)
                                ),
                                ...c.Items.filter(
                                    x =>
                                        x &&
                                        x.Status.StatusCode >=
                                            DisplayMessageMinimum
                                ).map(x => x.Status)
                            ].filter(fromShared.Errors.filterErrors)
                        )
                    ]),
                    catchError(fromShared.Errors.handleServiceError)
                )
            )
        )
    );
}
